export default {
  validate: (value, { maxValue }) => ({
    required: true,
    valid: /^[0-9]+$/.test(value) && Number(value) <= Number(maxValue),
  }),
  params: ['maxValue'],
  message: (fieldName, { _value_: v, maxValue }) => {
    if (!v) return 'Please enter the total claim cost in £';
    if (!/^-?[0-9]+$/.test(v)) return 'Please only enter numbers e.g. 300.';
    if (Number(v) > Number(maxValue)) return `The cost of repairs cannot exceed ${maxValue}.`;
    return 'Please enter the total claim cost in £';
  },
  computesRequired: true,
};
